(function () {
    'use strict';

    angular
        .module('app.shared')
        .factory('surveyModal', surveyModal);

    surveyModal.$inject = ['Survey', '$uibModal', '$q'];
    function surveyModal(Survey, $uibModal, $q) {
        return function surveyModal(individualId) {
            return $uibModal.open({
                size: 'sm',
                windowClass: 'postScoreAd',
                component: 'sc3SurveyModal',
                backdrop: 'static',
                keyboard: false, 
                resolve: {
                    data: function getData() {
                        return Survey.getQuestion({ individualId: individualId }).$promise.then(
                            function (result) {
                                result = result.toJSON();
                                return Object.keys(result).length ? result : $q.reject();
                            },
                            function error() {
                                return $q.reject();
                            }
                        );
                    }
                }
            });
        }
    }
})();